import { db } from '../../src/main'

// version 2 posting order
export function postShippingOrder (orderData) {
  return new Promise((resolve, reject) => {
    let postData = {}    // Resolve order data or reject blank data
    return db.runTransaction(transaction => {
      let storeGroup = orderData.storeGroup
      let bucketRef = db.collection('shippingNo').doc(storeGroup)
      return transaction.get(bucketRef).then(bucketSnapshot => {
        if (!bucketSnapshot.exists) {
          throw 'Unable to find the shipping bucket for store group'
        }

        let shippingNo
        let bucketData = bucketSnapshot.data()
        if (bucketData.main.available) {
          // Main bucket available
          shippingNo = bucketData.main.current
          if (shippingNo === bucketData.main.end) {
            bucketData.main.available = false     // last one in the bucket, close the bucket
          } else {
            bucketData.main.current ++
          }
        } else if (bucketData.backup.available) {
          // Main bucket unavailable, use backup
          shippingNo = bucketData.backup.current
          if (shippingNo === bucketData.backup.end) {
            bucketData.backup.available = false     // last one in the bucket, close the bucket
          } else {
            bucketData.backup.current ++
          }
        } else {
          // backup unavailable
          shippingNo = '需要到店分配'
        }

        transaction.set(bucketRef, bucketData)      // UPDATE SHIPPING NO BUCKET

        // prepare order and log data
        let orderRef = db.collection('order')
        postData = orderData
        postData.shippingNo = shippingNo

        // calculate package total weight
        let totalWeight = 0
        for (var i = 0; i < postData.packDetail.items.length; i++) {
          let item = postData.packDetail.items[i]
          totalWeight += parseFloat(item.weight)
        }
        postData.packDetail.totalWeight = totalWeight.toFixed(2)

        // Generate the inter-id for order
        postData.orderID = orderData.owner + '+' + shippingNo

        transaction.set(orderRef.doc(postData.orderID), postData)        // POST ORDER


        // initial log
        let logsRef = orderRef.doc(postData.orderID).collection('log').doc('Initial Log')
        let stamp = orderData.stamp
        let time = new Date(stamp)
        let logContent = {
          time: time,
          stamp: stamp,
          user: orderData.email,
          beforeChange: null,
          afterChange: postData
        }
        transaction.set(logsRef, logContent)      // POST LOG OF THE ORDER

        // Check if need to save the address to the address book
        let addressRef = db.collection('addressBook')
        if (postData.saveToAddressBook.save) {
          let address = postData.shipTo
          address.alias = postData.saveToAddressBook.alias
          address.owner = postData.owner
          let docRef = null
          if (postData.saveToAddressBook.docId === '') {
            docRef = addressRef.doc()
            address.docId = docRef.id
          } else {
            docRef = addressRef.doc(postData.saveToAddressBook.docId)
            address.docId = docRef.id
          }
          transaction.set(docRef, address)      // CONDITIONALLY POST ADDRESS UPDATE
        }
      })
    }).then(() => {
      resolve(postData)
    }).catch(err => {
      console.log(err)
      reject({})
    })
  })
}
// version 1 posting order
// export function postShippingOrder (orderData) {
//   return new Promise((resolve, reject) => {
//     db.collection('shippingNo').doc('info').get()
//       .then((info) => {
//         if (!info.exists) {
//           throw new Error('Unable to get shipping bucket info')
//         } else {
//           let shippingInfoRef = db.collection('shippingNo').doc('info')
//           let mainBucketRef = db.collection('shippingNo').doc(info.data().mainBucket)
//           let secondaryBucketRef = db.collection('shippingNo').doc(info.data().secondaryBucket)
//           let orderRef = db.collection('order')
//           let addressRef = db.collection('addressBook')
//           let postData = {}
//           return db.runTransaction(transaction => {
//             return transaction.get(mainBucketRef).then(mainBucket => {
//               if (mainBucket.data().available) {
//                 let bucket = mainBucket.data()
//                 let nextAvailable = bucket.current < bucket.end
//                 let nextNo = bucket.current + 1

//                 postData = orderData
//                 postData.shippingNo = bucket.current

//                 // calculate package total weight
//                 let totalWeight = 0
//                 for (var i = 0; i < postData.packDetail.items.length; i++) {
//                   let item = postData.packDetail.items[i]
//                   totalWeight += parseFloat(item.weight)
//                 }
//                 postData.packDetail.totalWeight = totalWeight.toFixed(2)

//                 // Generate the inter-id for order
//                 postData.orderID = orderData.owner + '+' + bucket.current

//                 transaction.update(mainBucketRef, { current: nextNo, available: nextAvailable })
//                 transaction.set(orderRef.doc(postData.orderID), postData)
//                 // initial log
//                 let stamp = orderData.stamp
//                 let time = new Date(stamp)
//                 let logContent = {
//                   time: time,
//                   stamp: stamp,
//                   user: orderData.email,
//                   beforeChange: null,
//                   afterChange: postData
//                 }
//                 let logsRef = orderRef.doc(postData.orderID).collection('log').doc('Initial Log')
//                 transaction.set(logsRef, logContent)

//                 // Check if need to save the address to the address book
//                 if (postData.saveToAddressBook.save) {
//                   let address = postData.shipTo
//                   address.alias = postData.saveToAddressBook.alias
//                   address.owner = postData.owner
//                   let docRef = null
//                   if (postData.saveToAddressBook.docId === '') {
//                     docRef = addressRef.doc()
//                     address.docId = docRef.id
//                   } else {
//                     docRef = addressRef.doc(postData.saveToAddressBook.docId)
//                     address.docId = docRef.id
//                   }
//                   transaction.set(docRef, address)
//                 }
//               } else {
//                 return transaction.get(secondaryBucketRef).then(secondaryBucket => {
//                   let bucket = secondaryBucket.data()
//                   let nextAvailable = bucket.current < bucket.end
//                   let nextNo = bucket.current + 1

//                   postData = orderData
//                   postData.shippingNo = bucket.current

//                   // calculate package total weight
//                   let totalWeight = 0
//                   for (var i = 0; i < postData.packDetail.items.length; i++) {
//                     let item = postData.packDetail.items[i]
//                     totalWeight += parseFloat(item.weight)
//                   }
//                   postData.packDetail.totalWeight = totalWeight.toFixed(2)

//                   // Generate the inter-id for order
//                   postData.orderID = orderData.owner + '+' + bucket.current

//                   transaction.update(secondaryBucketRef, { current: nextNo, available: nextAvailable })
//                   transaction.update(shippingInfoRef, { mainBucket: info.data().secondaryBucket })
//                   transaction.set(orderRef.doc(postData.orderID), postData)
//                   // initial log
//                   let stamp = orderData.stamp
//                   let time = new Date(stamp)
//                   let logContent = {
//                     time: time,
//                     stamp: stamp,
//                     user: orderData.email,
//                     beforeChange: null,
//                     afterChange: postData
//                   }
//                   let logsRef = orderRef.doc(postData.orderID).collection('log').doc('Initial Log')
//                   transaction.set(logsRef, logContent)

//                   // Check if need to save the address to the address book
//                   if (postData.saveToAddressBook.save) {
//                     let address = postData.shipTo
//                     address.alias = postData.saveToAddressBook.alias
//                     address.owner = postData.owner
//                     let docRef = null
//                     if (postData.saveToAddressBook.docId === '') {
//                       docRef = addressRef.doc()
//                       address.docId = docRef.id
//                     } else {
//                       docRef = addressRef.doc(postData.saveToAddressBook.docId)
//                       address.docId = docRef.id
//                     }
//                     transaction.set(docRef, address)
//                   }
//                 })
//               }
//             })
//           }).then(() => {
//             // console.log('transaction success')
//             resolve(postData)
//           }).catch(err => {
//             throw err
//           })
//         }
//       }).catch(err => {
//         reject(err)
//       })
//   })
// }

export function assignAnonymous (user) {
  // console.log('assignAnonymous')
  return new Promise((resolve, reject) => {
    let email = user.email
    return db.collection('order').where('email', '==', email).where('owner', '==', '').get()
      .then(querySnapShot => {
        return new Promise((resolve) => {
          let size = querySnapShot.size
          let queue = []
          querySnapShot.forEach(doc => {
            queue.push(doc.data())
            if (queue.length === size) {
              // console.log(queue)
              resolve(queue)
            }
          })
        })
      })
      .then(anonymousQueue => {
        // // console.log('run transaction')
        let counterRef = db.collection('counter').doc('Assign Anonymous')
        let orderRef = db.collection('order')
        return db.runTransaction(function (transaction) {
          return transaction.get(counterRef).then(function (doc) {
            // // console.log(doc.data())
            transaction = transaction.set(counterRef, { counter: doc.data().counter + 1 })
            if (anonymousQueue.length > 200) {
              throw new Error('More than 200 anonymous found!')
            }
            for (var i = 0; i < anonymousQueue.length; i++) {
              let order = anonymousQueue[i]
              let oldId = String(order.orderID)
              order.owner = user.uid
              order.orderID = user.uid + '+' + order.shippingNo
              // console.log(order)
              transaction.set(orderRef.doc(order.orderID), order)
              // log the transfer
              let stamp = Date.now()
              let time = new Date(stamp)
              transaction.set(orderRef.doc(order.orderID).collection('log').doc('Anonymous Transfer In'), { stamp: stamp, time: time })
              // console.log(anonymousQueue[i].orderID)
              transaction.delete(orderRef.doc(oldId))
            }
          })
            .catch(err => {
              // // console.log(err)
              reject(err)
            })
        }).then(() => {
          resolve('success')
        })
      })
      .catch(err => {
        reject(err)
      })
  })
}

export function changeOrderStatus (orderID, newStatus, user) {
  const availableStatus = ['Online', 'Collected', 'Cancelled']
  let stamp = Date.now()
  let time = new Date(stamp)
  let logsRef = db.collection('order').doc(orderID).collection('log').doc(String(stamp))
  let orderRef = db.collection('order').doc(orderID)
  return new Promise((resolve, reject) => {
    return db.runTransaction(transaction => {
      return transaction.get(orderRef).then(doc => {
        if (!doc.exists) {
          throw new Error('Target order not found')
        }
        let allowStatus = false
        let currentStatus = doc.data().status
        if (user.adminUser) {
          if (availableStatus.includes(newStatus)) {
            allowStatus = true
          } else {
            throw new Error('Invalid operation => ', newStatus, '. Must be one of => ', availableStatus)
          }
        } else {
          // for normal user, only below operation is allowed
          if (currentStatus === 'Online' && newStatus === 'Cancelled') {
            allowStatus = true
          } else {
            throw new Error('Invalid op for normal user')
          }
        }
        if (allowStatus) {
          let newOrder = doc.data()
          newOrder.status = newStatus
          let logContent = {
            time: time,
            stamp: stamp,
            user: user.email,
            beforeChange: doc.data(),
            afterChange: newOrder,
            operation: 'Change Status'
          }
          transaction.update(orderRef, { status: newStatus })
          transaction.set(logsRef, logContent)
        }
      })
    })
      .then(() => {
        resolve('Status has been changed')
      })
      .catch(err => {
        reject(err)
      })
  })
}

export function calcShippingFee (items, province) {
  const FAR_PROVINCE = ['内蒙古自治区', '西藏自治区', '新疆维吾尔自治区']
  let isFar = FAR_PROVINCE.includes(province)
  // calc no tax price
  let tax = 0
  let b2cPrice = 0
  let noTaxPackedPrice = 0
  let noTaxUnpackedPrice = 0
  for (var i = 0; i < items.length; i++) {
    let item = items[i]
    let category = item.category
    let price = parseFloat(item.price)
    let qty = parseFloat(item.qty)
    let weight = parseFloat(item.weight)

    tax += price * qty * 0.112
    b2cPrice += weight * (isFar ? 5.00 : 3.50)
    noTaxPackedPrice += getPrice(category, province, false) * weight
    noTaxUnpackedPrice += getPrice(category, province, true) * weight
  }
  return {
    tax: tax.toFixed(2), // the tax for b2c method
    b2c: b2cPrice.toFixed(2),
    packaged: noTaxPackedPrice.toFixed(2),
    unpackaged: noTaxUnpackedPrice.toFixed(2)
  }
}

function getPrice (category, province, unpacked) {
  // // console.log('province', province)
  const CAT_A = ['Health_Supplement', 'Baby_Formula', 'Baby_Care', 'Clothes', 'Daily_Necessities', 'Other']
  const CAT_B = ['Shoes']
  const CAT_C = ['Bag', 'Electronics', 'Accessories', 'Cosmetic', 'Watch']
  const FAR_PROVINCE = ['内蒙古自治区', '西藏自治区', '新疆维吾尔自治区']
  let isFar = FAR_PROVINCE.includes(province)
  // price based on weight for province [non-vip-FAR, vip-FAR] : [non-vip-, vip]
  // // console.log('isFar', isFar)
  const PRICE_A = isFar ? [6, 5.3] : [4.5, 3.8]
  const PRICE_B = isFar ? [6, 5.5] : [4.5, 4]
  const PRICE_C = isFar ? [7.5, 6.8] : [6, 5.3]

  if (CAT_A.includes(category)) {
    return unpacked ? PRICE_A[1] : PRICE_A[0]
  } else if (CAT_B.includes(category)) {
    return unpacked ? PRICE_B[1] : PRICE_B[0]
  } else if (CAT_C.includes(category)) {
    return unpacked ? PRICE_C[1] : PRICE_C[0]
  } else {
    return unpacked ? PRICE_A[1] : PRICE_A[0]
  }
}

export function postEdit (order, user) {
  let orderRef = db.collection('order').doc(order.orderID)
  let stamp = Date.now()
  let time = new Date(stamp)
  let logsRef = db.collection('order').doc(order.orderID).collection('log').doc(String(stamp))
  return new Promise((resolve, reject) => {
    return db.runTransaction(transaction => {
      return transaction.get(orderRef).then(doc => {
        if (!doc.exists) {
          throw 'Order doesn\'t exist'
        }
        let logContent = {
          time: time,
          stamp: stamp,
          user: user.email,
          beforeChange: doc.data(),
          afterChange: order,
          operation: 'Edit by Merchant'
        }
        transaction.set(orderRef, order)
        transaction.set(logsRef, logContent)
      })
    }).then(() => {
      resolve('Edited order updated')
    }).catch(err => {
      reject(err)
    })
  })
}
